// client\src\Utilities\socketClient.js
// ⚠️ Deprecated file – do not use
export const initSocket = () => {
    console.error('❌ socketClient.js should not be used');
    return null;
};

export const getSocket = () => null;
export const reconnectWithFreshToken = () => { };
export const emitHeartbeat = () => { };
